module.exports = __webpack_public_path__ + "static/29-7cbbc0cd90c4857ed5fe2cf6b4946c36.png";